<template>
  <div class="content">
    <div class="speed">
      ©
      <a v-if="orgType === 'association'" href="https://associacoes.org" target="_blank">
        associacoes.org
      </a>
      <a v-else-if="orgType === 'cooperative'" href="https://coops.org" target="_blank">
        coops.pt
      </a>
      {{ new Date().getFullYear() }} | tempo da última resposta: {{ responseTime }} ms
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'FooterEl',
  computed: {
    responseTime() {
      return this.$store.state.responseTime
    },
    ...mapGetters({
      orgType: 'settings/orgType',
    }),
  },
}
</script>

<style lang="scss" scoped>
.content {
  text-align: center;
  padding: 2rem;
  color: white;
  .speed {
    font-size: 0.6rem;
  }
}

a {
  color: white;
}
</style>
